
import Vue from 'vue';

interface Props {
  isHeadlinesPage: boolean;
}
export default Vue.extend<unknown, unknown, unknown, Props>({
  props: {
    isHeadlinesPage: {
      type: Boolean,
      default: false,
    },
  },
});
